import { setFirestoreDoc } from "./firestore"

export function Test() {
	const data = {mama: 'llama samba'};
	setFirestoreDoc('/pending/test', data);
	return(
		<><h1>Testing</h1>
		</>
	)
}
